import styled from 'styled-components';
import {PlayRealButtonDefaultBox} from './play-real-button.default.box';

export const PlayRealButtonCasino777Box = styled(PlayRealButtonDefaultBox)`
    background-position: -195px -354px;
    width: 6.3rem;
    height: 6.3rem;

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        background-position: -201px -358px;
    }
`;